import { useContext, useState } from "react";

import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";

import { Box, IconButton, Slider, Stack } from "@mui/material";
import VolumeDown from "@mui/icons-material/VolumeDown";
import VolumeUp from "@mui/icons-material/VolumeUp";

import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import SessionContext from "../../../contexts/session";
import { useTranslation, Trans } from "react-i18next";

function SimpleDialog(props) {
  const { t } = useTranslation();
  const { volume, setVolume } = useContext(SessionContext);

  const { onClose, selectedValue, open } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleChange = (event, newValue) => {
    setVolume(newValue);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle><Trans t={t}>Game Settings</Trans></DialogTitle>
      <Box sx={{ width: 200, m: 3 }}>
        <Stack direction="row" sx={{ mb: 1 }} alignItems="center">
          <VolumeDown />
          <Slider
            min={0}
            max={1}
            step={0.01}
            aria-label="Volume"
            value={volume}
            onChange={handleChange}
          />
          <VolumeUp />
        </Stack>
      </Box>
    </Dialog>
  );
}

export default function GameSettings() {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ marginLeft: "auto" }}>
      <IconButton onClick={handleClickOpen} sx={{ marginLeft: "auto" }}>
        <SettingsRoundedIcon />
      </IconButton>
      <SimpleDialog open={open} onClose={handleClose} />
    </Box>
  );
}
